import { IAttachment } from '@shared/models/proto/base/attachment'
import {
  EmbeddedAttachment,
  EmbeddedAttachment_AttachedBooking,
  EmbeddedAttachment_AttachedFaq,
  EmbeddedAttachment_AttachedFormSubmission,
  EmbeddedAttachment_AttachedQuickForm,
  EmbeddedAttachment_AttachedQuickSignDocument,
} from '@shared/proto-ts/qliq_protobuf/chat/embedded_attachment_pb'
import { getFirstArrayItem } from '@shared/utils/helpers/array/get-first-array-item'

import { LocalizedEntity } from '@protos/localized_entity_pb'

export const mergeAttachmentToEmbeddedAttachment = (
  attachments: Array<IAttachment>
) => {
  const attachment = getFirstArrayItem(attachments)
  if (attachment) {
    const updatedEmbeddedAttachment = new EmbeddedAttachment({
      id: attachment.id,
      thumbnailUrl: attachment.thumbnailUrl,
      url: attachment.url,
      contentType: attachment.contentType,
      createdAt: attachment.createdAt,
      iv: attachment.iv,
      inline: attachment.inline,
      key: attachment.key,
      fileName: attachment.fileName,
      dataUrl: attachment.dataUrl,
      shouldExpand: attachment.shouldExpand,
      encryptAttachments: attachment.encryptAttachments,
      payload: { ...generateAttachmentPayload(attachment) },
    })
    return updatedEmbeddedAttachment
  }
  return null
}

export const generateAttachmentPayload = (
  attachment: IAttachment
): EmbeddedAttachment['payload'] => {
  if (attachment.form) {
    return {
      case: 'form',
      value: new EmbeddedAttachment_AttachedQuickForm({
        id: attachment.form.id,
        uuid: attachment.form.uuid,
        name: attachment.form.name,
      }),
    }
  } else if (attachment.formSubmission) {
    return {
      case: 'formSubmission',
      value: new EmbeddedAttachment_AttachedFormSubmission({
        id: attachment.formSubmission.id,
        uuid: attachment.formSubmission.uuid,
        formUuid: attachment.formSubmission.form?.uuid ?? '',
        name: (attachment.formSubmission?.form?.name ||
          []) as LocalizedEntity[],
      }),
    }
  } else if (attachment.faq) {
    return {
      case: 'faq',
      value: new EmbeddedAttachment_AttachedFaq({
        id: attachment.faq.id,
        uuid: attachment.faq.uuid,
      }),
    }
  } else if (attachment.booking) {
    return {
      case: 'booking',
      value: new EmbeddedAttachment_AttachedBooking({
        id: attachment.booking.id,
        uuid: attachment.booking.uuid,
      }),
    }
  } else if (attachment.quickSignDocument) {
    return {
      case: 'quickSignDocument',
      value: new EmbeddedAttachment_AttachedQuickSignDocument({
        id: attachment.quickSignDocument.id,
        uuid: attachment.quickSignDocument.uuid,
        fileName: attachment.quickSignDocument.signName,
        status: attachment.quickSignDocument?.status,
      }),
    }
  } else {
    return {} as EmbeddedAttachment['payload']
  }
}
